import React from "react";
import ProfileView from "../../components/profile/ProfileView";
import { useAuth } from "../../contexts/AuthContext";

// حسابي — the logged-in user's own profile (replaces the old فئاتي page).
const Profile = () => {
  const { user } = useAuth();
  return <ProfileView userId={user?._id} isOwn />;
};

export default Profile;
